import { render, staticRenderFns } from "./OHSEducation.vue?vue&type=template&id=30a55cb0&"
import script from "./OHSEducation.vue?vue&type=script&lang=js&"
export * from "./OHSEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports